import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";

// Front
import LayoutReducer from "./layouts/reducer";

// login
import LoginReducer from "./auth/login/reducer";

// register
import RegisterReducer from "./auth/register/reducer";

// userProfile
import ProfileReducer from "./auth/profile/reducer";

// users
import UsersReducer from "./users/reducer";

// admin users
import AdminUsersReducer from "./users/adminUsersSlice";

// market
import MarketReducer from "./market/marketSlice";
import StarlineMarketReducer from "./starlineMarket/starlineMarketSlice";

// result management
import ResultReducer from "./result/resultSlice";
import StarlineResultReducer from "./starline/starlineResultSlice";

// bet history
import BetHistoryReducer from "./betHistory/betHistorySlice";
import StarlineBetHistoryReducer from "./starlineBetHistory/betHistorySlice";

// payout multiplier
import PayoutMultiplierReducer from "./payoutMultiplier/payoutMultiplierSlice";

// apps
import AppsReducer from "./apps/appsSlice";
import ReferralReducer from "./referral/referralSlice";
import ReferredUsersReducer from "./referredUsers/referredUsersSlice";
import ManualDepositsReducer from "./finance/manualDepositsSlice";
import WithdrawRequestsReducer from "./finance/withdrawRequestsSlice";
import BankAccountsReducer from "./bank/bankAccountsSlice";
import AgentUsersReducer from "./agentUsers/agentUsers";
import UserManagementReducer from "./users/userManagementSlice";
import NotificationsReducer from "./notifications/notificationsSlice";
import ChangePasswordReducer from "./auth/changePasswordSlice";
import RolesReducer from "./roles/rolesSlice";
import PaymentsReducer from "./payments/paymentSlice";
import PaymentGatewaysReducer from "./paymentGateways/paymentGatewaysSlice";
import SalesReportReducer from "./salesReport/salesReportSlice";
import SupportReducer from "./support/supportSlice";
import RegistrationReducer from "./registration/registerSlice";
import GameRateReducer from "./GameRates/GameRateSlice";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Register: RegisterReducer,
    Profile: ProfileReducer,
    Users: UsersReducer,
    AdminUsers: AdminUsersReducer,
    Market: MarketReducer,
    StarlineMarket: StarlineMarketReducer,
    Result: ResultReducer,
    StarlineResult: StarlineResultReducer,
    BetHistory: BetHistoryReducer,
    StarlineBetHistory: StarlineBetHistoryReducer,
    PayoutMultiplier: PayoutMultiplierReducer,
    Apps: AppsReducer,
    Referral: ReferralReducer,
    ReferredUsers: ReferredUsersReducer
    ,ManualDeposits: ManualDepositsReducer
    ,BankAccounts: BankAccountsReducer
    ,WithdrawRequests: WithdrawRequestsReducer
    ,AgentUsers: AgentUsersReducer
    ,UserManagement: UserManagementReducer
    ,Notifications: NotificationsReducer
    ,ChangePassword: ChangePasswordReducer
    ,Roles: RolesReducer
    ,Payments: PaymentsReducer
    ,PaymentGateways: PaymentGatewaysReducer
    ,SalesReport: SalesReportReducer
    ,Support: SupportReducer
    ,Registration: RegistrationReducer
    ,GameRate: GameRateReducer
});

export type RootState = ReturnType<typeof rootReducer>;

// Create store for AppDispatch type
const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;

export default rootReducer;